module.exports = __webpack_public_path__ + "img/sushi-icon.c432cd21.png";